@if (!isPrintVersion() && params(); as params) {
  <button nkButton [ghost]="true" color="danger" size="xs" (click)="openScreeningRemovePersonModal(params)">
    {{ 'screening.screening_overrides.remove_from_screening' | translate }}
    <i class="fa fa-minus ms-2"></i>
  </button>
}
